import { XMarkIcon } from '@heroicons/react/24/outline';
import { APIProvider } from '@vis.gl/react-google-maps';
import { Button } from 'react-daisyui';
import { useTranslation } from 'react-i18next';
import { eChannelType } from '../../../../../../../../providers/SocketsProvider/Sockets.enums.ts';
import { ChatEnum } from '../../../../../../Chat.enum.ts';
import { useChatContext } from '../../../../../../Chat.hook.ts';
import { useMessageBarContext } from '../../../../MessageBar.hook.ts';
import GoogleMapsPicker from './GoogleMapsPicker.component.tsx';
import useGoogleMapsAction from './GoogleMapsAction.hooks.tsx';
import './GoogleMapsAction.styles.scss';

export default function GoogleMapsAction() {
  const { setSelectedAction } = useMessageBarContext();
  const { selectedChat } = useChatContext();
  const { t } = useTranslation('chat/chat');
  const {
    userLocation,
    place,
    handlePlacePicked,
    clearPlace,
    handleSelectLocation,
    dropdownRef,
    handleMarkerDragEnd,
  } = useGoogleMapsAction();
  // Only WhatsApp API sends the place's name to the lead (INT-1720).
  const sendsPlaceName =
    selectedChat?.integration === eChannelType.WHATSAPP_API;

  return (
    <div className="GoogleMapsContainer">
      <div ref={dropdownRef} className="GoogleMapsContainer__Map">
        <XMarkIcon
          className="GoogleMapsContainer__CloseIcon"
          onClick={() => setSelectedAction(ChatEnum.CHAT)}
        />
        <APIProvider apiKey={import.meta.env.VITE_API_KEY}>
          <GoogleMapsPicker
            userLocation={userLocation}
            onPlacePicked={handlePlacePicked}
            onMarkerDragEnd={handleMarkerDragEnd}
          />
        </APIProvider>
        {place && (
          <div className="GoogleMapsContainer__Place">
            <div className="GoogleMapsContainer__PlaceText">
              <span className="GoogleMapsContainer__PlaceName">
                {place.name}
              </span>
              {place.address && (
                <span className="GoogleMapsContainer__PlaceAddress">
                  {place.address}
                </span>
              )}
              {!sendsPlaceName && (
                <span className="GoogleMapsContainer__PlaceHint">
                  {t('googleMapsAction.placeNameOnlyWapi')}
                </span>
              )}
            </div>
            <button
              type="button"
              aria-label={t('googleMapsAction.clearPlace')}
              onClick={clearPlace}
            >
              <XMarkIcon className="GoogleMapsContainer__PlaceClear" />
            </button>
          </div>
        )}
        <Button
          onClick={handleSelectLocation}
          color="primary"
          className="w-full"
        >
          {t('googleMapsAction.sendLocation')}
        </Button>
      </div>
    </div>
  );
}
